import React from 'react'
import { useNavigate } from "react-router-dom";
function Footer() {
   const navigate = useNavigate();
      const moveToHome = (e) => {
          e.preventDefault();
          navigate("/dashboard");
      }
  return (
    <footer class="pc-footer">
    <div class="footer-wrapper container-fluid">
      <div class="row">
        <div class="col-sm my-1">
          <p class="m-0">Copyright © <a href="https://www.mbose.in/" target='_blank' rel="noreferrer">Meghalaya Board of School Education</a></p>
        </div>
        {/* <div class="col-auto my-1">
          <ul class="list-inline footer-link mb-0">
            <li class="list-inline-item"><a href="/" onClick={moveToHome}>Home</a></li>
          </ul>
        </div> */}
      </div>
    </div>
  </footer>
  )
}

export default Footer